export const customNameComparator = (v1: any, v2: any): number | undefined => {
	const stringifiedV1 = JSON.stringify(v1);
	const stringifiedV2 = JSON.stringify(v2);
	if (!stringifiedV1 && !stringifiedV2) return;
	return stringifiedV1.localeCompare(stringifiedV2);
};

export const customVersionComparator = (v1: string | null | undefined, v2: string | null | undefined): number => {
	if (!v1 || !v2) return 0;
	
	const targetVersionParts = v1.split(".").map(Number);
	const currentVersionParts = v2.split(".").map(Number);
  
	const len = Math.max(targetVersionParts.length, currentVersionParts.length);
	for (let i = 0; i < len; i++) {
		const a = targetVersionParts[i] || 0;
		const b = currentVersionParts[i] || 0;
		if (a > b) return 1;
		if (a < b) return -1;
	}
	return 0;
};
